import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UiHelperService } from 'ClientApp/app/shared/cardholders-core/services/ui-helper.service';
import { Subscription } from 'rxjs';
import { GtmService } from '../../../../shared/cardholders-core/services/gtm.service';
import { DirectDebitService } from '../../services/direct-debit.service';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit, OnDestroy {
    subtitle = '';
    message = '';
    icon = '';
    title = '';
    subMainTitle = '';
    btn = '';
    headerMobileImage = '';
    headerDesktopImage = '';
    link = '';
    showLink = false;
    subs: Subscription[] = [];
    constructor(
        private directDebSrv: DirectDebitService,
        private router: Router,
        private activeRoute: ActivatedRoute,
        private gtmService: GtmService,
        private uiHelper: UiHelperService
    ) {}
    ngOnDestroy(): void {
        this.subs.forEach((s) => s.unsubscribe());
    }

    ngOnInit(): void {
        this.gtmService.pushDirectDebit('error', 'load');
        this.setErrorMessage();
    }
    get bgImg(): string {
        return `url(${
            this.uiHelper.IsMobile() ? this.headerMobileImage : this.headerDesktopImage
        }) 0% 0%  no-repeat`;
    }
    setErrorMessage(): void {
        this.title = 'העברת הוראות קבע מכרטיס לכרטיס';
        this.subs.push(
            this.directDebSrv.contents$.subscribe((content) => {
                if (content) {
                    this.title = content.success.title;
                    this.subMainTitle = content.success.subTitle;
                    this.headerMobileImage = content.success.headerMobileImage;
                    this.headerDesktopImage = content.success.headerMobileImage;
                }
            })
        );
        try {
            switch (this.directDebSrv.fromError) {
                case 'getContentAndData': {
                    switch (this.directDebSrv.rcError) {
                        case 10:
                            this.message = 'לא מצאנו כרטיס שאליו אפשר להעביר את הוראות הקבע שלך.';
                            this.icon = 'icecream.svg';
                            this.btn = 'חזרה לעמוד הבית ';
                            this.showLink = false;
                            break;

                        default:
                            throw new Error();
                    }

                    break;
                }
                case 'Destination': {
                    switch (this.directDebSrv.rcError) {
                        case 10:
                            this.message =
                                'כבר קיימת בקשה על הכרטיס ממנו ביקשת להעביר הוראת קבע. כדאי להתעדכן בפירוט החיובים החודשי הקרוב שלך ולוודא שהוראות הקבע שלך עברו.';
                            this.icon = 'turtle.svg';
                            this.btn = 'תודה';
                            this.showLink = false;
                            break;
                        case 12:
                            this.message = 'לא ניתן להעביר הוראות קבע מכרטיס שהונפק בחו"ל';
                            this.icon = 'turtle.svg';
                            this.btn = 'אני אקליד כרטיס אחר';
                            this.link = 'אני אוותר עכשיו';
                            this.showLink = true;
                            break;
                        case 13:
                            this.message =
                                'נראה שאין ברשותך כרטיסים פעילים שאפשר להעביר אליהם הוראות קבע, אם יש לך כרטיס אחר, אפשר להעביר גם ממנו את הוראות הקבע שלך. ';
                            this.icon = 'turtle.svg';
                            this.btn = 'שנעביר מכרטיס אחר';
                            this.link = 'אני אוותר תודה';
                            this.showLink = true;
                            break;
                        case 14:
                            this.subtitle = 'משהו השתבש לנו';
                            this.message = 'אופס, נראה שמשהו לא מסתדר לנו עם מספר הכרטיס שמילאת. <br>שננסה שוב?';
                            this.icon = 'icecream.svg';
                            this.btn = 'אני אנסה שוב';
                            this.link = 'אני אוותר תודה';
                            this.showLink = true;
                            break;
                        case 15:
                            this.message = 'נראה שאין הוראות קבע על הכרטיס, צריך למלא כרטיס אחר';
                            this.icon = 'turtle.svg';
                            this.btn = 'אני רוצה למלא כרטיס אחר';
                            this.link = 'אני אוותר';
                            this.showLink = true;
                            break;
                        case 16:
                            this.message =
                                'אפשר להעביר הוראות קבע רק מהכרטיסים שלך ולא מכרטיסים אחרים של max שננסה שוב?';
                            this.icon = 'turtle.svg';
                            this.btn = 'אני רוצה לנסות שוב';
                            this.link = 'אני אוותר';
                            this.showLink = true;
                            break;
                        case 17:
                            this.message = 'נראה שאין הוראות קבע על הכרטיס צריך למלא כרטיס אחר';
                            this.icon = 'turtle.svg';
                            this.btn = 'אני רוצה לנסות שוב';
                            this.link = 'אני אוותר';
                            this.showLink = true;
                            break;
                        case 19:
                            this.message = 'בית העסק לא מאפשר את העברת הוראת הקבע, מומלץ לפנות לבית העסק לבצוע הפעולה';
                            this.icon = 'turtle.svg';
                            this.btn = 'חזרה לדף הבית';
                            this.showLink = false;
                            break;
                        default:
                            throw new Error();
                    }
                    break;
                }
                default:
                    throw new Error();
            }
        } catch (error) {
            this.subtitle = 'משהו השתבש לנו';
            this.message = 'משהו השתבש לנו, אפשר לנסות להקליד את הכרטיס בשנית או לנסות מאוחר יותר';
            this.icon = 'turtle.svg';
            this.title = 'העברת הוראות קבע מכרטיס לכרטיס';
            this.btn = 'חזרה לעמוד הבית';
        }
    }

    next(): void {
        this.gtmService.pushDirectDebit('error', 'click');
        try {
            switch (this.directDebSrv.fromError) {
                case 'getContentAndData': {
                    switch (this.directDebSrv.rcError) {
                        case 10:
                            this.router.navigate(['/']);
                            break;
                        default:
                            throw new Error();
                    }

                    break;
                }
                case 'Destination': {
                    switch (this.directDebSrv.rcError) {
                        case 10:
                        case 19:
                            this.router.navigate(['/']);
                            break;
                        case 12:
                        case 13:
                        case 14:
                        case 15:
                        case 16:
                        case 17:
                            this.router.navigate(['../check-for-card'], { relativeTo: this.activeRoute });
                            break;
                        default:
                            throw new Error();
                    }
                    break;
                }

                default:
                    throw new Error();
            }
        } catch (error) {
            this.router.navigate(['/']);
        }
    }

    linkClick(): void {
        this.gtmService.pushDirectDebit('error', 'link click');
        this.router.navigate(['/']);
    }
}
